module.exports = __webpack_public_path__ + "static/img/jisuan.474de1c.474de1c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/jisuan.474de1c.png
// module id = J5MW
// module chunks = 1